import React, { useEffect } from 'react'
import {
  createHashRouter,
  Outlet,
  RouteObject,
  RouterProvider,
  useLocation,
} from 'react-router-dom'
import { useGoogleAnalytics } from '@plug-core/providers/GoogleAnalyticsProvider'
import { GAEventName } from '@plug-core/interfaces/googleAnalytics'
import { getPageInfo } from '@plug-core/utils/getPageInfo'
import AnimatedRoute from '@components/AnimatedRoute'
import Toast from '@components/Toast'
import { Rerouter } from '@components/Router/Router'
import { WALLET_SETUP_ROUTES } from '@utils/walletSetupRoutes'
import { WalletSetupBackupSeed } from './components/BackupSeed'
import { WalletSetupImportSeed } from './components/ImportSeed'
import { WalletSetupOptions } from './components/SetupOptions'
import { WalletSetupPassword } from './components/SetupPassword'
import { WalletSetupSuccess } from './components/SetupSuccess'
import { getWindowDimensions } from '@utils/windows'
import { POPUP_DIMENSIONS } from '@misc/constants'
import { Stack, Typography } from '@mui/material'

export const WALLET_SETUP_ROUTE_DATA: RouteObject[] = [
  {
    path: WALLET_SETUP_ROUTES.WALLET_SETUP,
    element: (
      <AnimatedRoute animationDirection="base" navbar={false}>
        <WalletSetupOptions />
      </AnimatedRoute>
    ),
    index: true,
  },
  {
    path: WALLET_SETUP_ROUTES.PASSWORD,
    element: (
      <AnimatedRoute animationDirection="right" navbar={false}>
        <WalletSetupPassword />
      </AnimatedRoute>
    ),
  },
  {
    path: WALLET_SETUP_ROUTES.IMPORT_SEED,
    element: (
      <AnimatedRoute animationDirection="right" navbar={false}>
        <WalletSetupImportSeed />
      </AnimatedRoute>
    ),
  },
  {
    path: WALLET_SETUP_ROUTES.BACKUP_SEED,
    element: (
      <AnimatedRoute animationDirection="right" navbar={false}>
        <WalletSetupBackupSeed />
      </AnimatedRoute>
    ),
  },
  {
    path: WALLET_SETUP_ROUTES.SUCCESS,
    element: (
      <AnimatedRoute animationDirection="right" navbar={false}>
        <WalletSetupSuccess />
      </AnimatedRoute>
    ),
  },
]

const RootLayot = () => {
  const { fireEvent } = useGoogleAnalytics()
  const { pathname } = useLocation()

  useEffect(() => {
    fireEvent(GAEventName.PAGE_VIEW, getPageInfo(WALLET_SETUP_ROUTES, pathname))
  }, [pathname])

  return (
    <>
      <Outlet />
      <Toast />
    </>
  )
}

const router = createHashRouter([
  {
    element: <RootLayot />,
    children: WALLET_SETUP_ROUTE_DATA,
    errorElement: <Rerouter root={WALLET_SETUP_ROUTES.WALLET_SETUP} />,
  },
])

export const WalletSetup = () => {
  const { height, width } = getWindowDimensions()

  const isPopup = height === POPUP_DIMENSIONS.height && width === POPUP_DIMENSIONS.width

  if (isPopup) {
    window.open(window.location.href, '_blank')
  } else {
    return (
      <Stack
        bgcolor={(theme) => theme.palette.background.paper}
        justifyContent="center"
        alignItems="center"
        width="100vw"
        height="100vh"
      >
        <Typography variant="h2" position="absolute" top={20} left={40}>
          plug
        </Typography>

        <Stack
          bgcolor={(theme) => theme.palette.background.default}
          sx={{ borderRadius: 3 }}
          boxSizing="border-box"
          width={POPUP_DIMENSIONS.width}
          height={POPUP_DIMENSIONS.height}
          overflow="hidden"
          position="relative"
        >
          <RouterProvider router={router} />
        </Stack>
      </Stack>
    )
  }
}

export {
  WalletSetupBackupSeed,
  WalletSetupImportSeed,
  WalletSetupOptions,
  WalletSetupPassword,
  WalletSetupSuccess,
}
